module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationKoreaThumb.1086139b.jpg";